import { createFileRoute } from '@tanstack/react-router';

import { OperationDetailShell } from '../../features/operations/operation-detail-shell';
import { operationBreadcrumbBadges } from '../../features/operations/operation-route-chrome';
import { OperationStations } from '../../features/operations/operation-stations';
import { operationDetailQueryOptions } from '../../features/operations/queries';

export const Route = createFileRoute('/operations/$operation_id_/stations')({
  staticData: {
    breadcrumb: (match, queryClient) => {
      const { operation_id: operationId } = match.params as { operation_id: string };
      const data = queryClient.getQueryData(operationDetailQueryOptions(operationId).queryKey);
      return data ? `${data.operation_name} — Stations` : 'Operation Stations';
    },
    breadcrumbBadges: operationBreadcrumbBadges,
    layout: 'full-height',
  },
  component: OperationStationsPage,
});

function OperationStationsPage() {
  const { operation_id: operationId } = Route.useParams();

  return (
    <OperationDetailShell operationId={operationId} active="stations">
      {(operation) => <OperationStations operation={operation} />}
    </OperationDetailShell>
  );
}
